import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg height="24" fill="none" width="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" stroke="#000" strokeLinecap="round" strokeLinejoin="round" /></svg>;